// Imported first in main.js (ES imports run in order), so personal details
// are out of the URL before the router or anything else reads it. The inline
// script in public/index.html normally did this already, before GTM.
import { stripPersonalParams } from "./prefill";

stripPersonalParams();
